import { useMemo } from "react";
import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { isSuperAdminRole } from "@Front/Utils/officeRoleStatusHelpers";

export function useMenuIsSuperAdmin(
	permissionContext: PermissionContextDto | null,
	loadingPermissions: boolean,
): boolean {
	return useMemo(() => {
		if (loadingPermissions || !permissionContext) {
			return false;
		}
		return permissionContext.isSuperAdmin === true || isSuperAdminRole(permissionContext.globalRole);
	}, [permissionContext, loadingPermissions]);
}
